import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "track", "href", "external", "prefetch", "component"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// ignore-string-externalization
import React from 'react';
import qs from 'query-string';
import NextLink from 'next/link';
import { hexToRgba } from '@mrkt/features/color-conversion';
import styled, { css } from 'styled-components';
import { white } from '@spotify-internal/encore-foundation';
import { useTracking } from '../Tracking';
import { useRouter } from 'next/router';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultComponent = styled.a.withConfig({
  displayName: "Link__defaultComponent",
  componentId: "sc-170gxkp-0"
})([""]);
/**
 * Wraps NextJS link, adds:
 * - track: GA tracking (required, auto for external)
 * - external: opens external links in new tab, etc.
 * - adds 'a' component with default link styles, configurable
 */

export var UnstyledLink = function UnstyledLink(props) {
  var children = props.children,
      track = props.track,
      href = props.href,
      _props$external = props.external,
      external = _props$external === void 0 ? false : _props$external,
      _props$prefetch = props.prefetch,
      prefetch = _props$prefetch === void 0 ? true : _props$prefetch,
      _props$component = props.component,
      AComponent = _props$component === void 0 ? defaultComponent : _props$component,
      extraProps = _objectWithoutProperties(props, _excluded);

  var _useTracking = useTracking(),
      eventHandler = _useTracking.eventHandler,
      eventHandlerWithAction = _useTracking.eventHandlerWithAction;

  var router = useRouter();
  var linkProps = extraProps;
  var aProps = {};
  var url = href; // always try to pass the 'plain' parameter to the next URL

  if ('plain' in ((router === null || router === void 0 ? void 0 : router.query) || {})) {
    var _qs$parseUrl = qs.parseUrl(url),
        u = _qs$parseUrl.url,
        q = _qs$parseUrl.query;

    q.plain = null;
    url = "".concat(u, "?").concat(qs.stringify(q));
  }

  if (track) {
    var _track = _slicedToArray(track, 3),
        trackCategory = _track[0],
        trackLabel = _track[1],
        trackAction = _track[2];

    if (external) {
      trackCategory = trackCategory || 'External Link';
      trackLabel = trackLabel || url;
      trackAction = trackAction || 'click';
    }

    if (trackCategory && trackLabel && trackAction) {
      aProps.onClick = eventHandlerWithAction("Frodor - ".concat(trackCategory), trackAction, trackLabel);
    } else if (trackCategory && trackLabel) {
      aProps.onClick = eventHandler("Frodor - ".concat(trackCategory), trackLabel);
    }
  }

  if (external) {
    aProps.target = '_blank';
    aProps.rel = 'noopener noreferrer';
  }

  if (linkProps.highlight) {
    aProps.className = 'highlight';
  }

  delete linkProps.highlight;
  aProps.tabIndex = linkProps.tabIndex;
  delete linkProps.tabIndex;

  if (prefetch === false || external || url && (url.startsWith('http') || url.startsWith('//') || url === '/c' || url.startsWith('/c/'))) {
    linkProps.prefetch = false;
  }

  aProps.className = "".concat(aProps.className || '', " ").concat(linkProps.className || '');
  delete linkProps.className; // pass along all data & aria props to href

  var _iterator = _createForOfIteratorHelper(Object.keys(linkProps).filter(function (k) {
    return k.startsWith('aria-') || k.startsWith('data-');
  })),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _key = _step.value;
      aProps[_key] = linkProps[_key];
      delete linkProps[_key];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (external) {
    return /*#__PURE__*/_jsx(AComponent, _objectSpread(_objectSpread({}, aProps), {}, {
      href: url,
      children: children
    }));
  }

  return /*#__PURE__*/_jsx(NextLink, _objectSpread(_objectSpread({}, linkProps), {}, {
    href: url,
    passHref: true,
    children: /*#__PURE__*/_jsx(AComponent, _objectSpread(_objectSpread({}, aProps), {}, {
      children: children
    }))
  }));
};
export var getLinkStyle = function getLinkStyle(props) {
  var _props$theme$link, _props$theme$link2, _props$theme$link3;

  return css(["text-decoration:none;color:", ";&:hover,&:focus:not(:disabled),&:active:not(:disabled),&.highlight{text-decoration:none;color:", ";-webkit-tap-highlight-color:", ";}&::after{border-bottom:0;}&:focus:not(:disabled){outline:thin dotted black;}"], hexToRgba(props.customTextColor || ((_props$theme$link = props.theme.link) === null || _props$theme$link === void 0 ? void 0 : _props$theme$link.color) || white, 0.75), props.customTextColor || ((_props$theme$link2 = props.theme.link) === null || _props$theme$link2 === void 0 ? void 0 : _props$theme$link2.color) || white, ((_props$theme$link3 = props.theme.link) === null || _props$theme$link3 === void 0 ? void 0 : _props$theme$link3.tap) || 'transparent');
};
export var Link = styled(UnstyledLink).withConfig({
  displayName: "Link",
  componentId: "sc-170gxkp-1"
})(["", ""], function (props) {
  return getLinkStyle(props);
});